import { createTheme } from 'react-data-table-component';

// Register shared solarized theme (visible pagination icons, no big circle on hover)
createTheme('solarized', {
    text: {
        primary: 'rgb(86, 86, 114)',
    },
    background: {
        default: 'transparent',
    },
    divider: {
        default: 'rgb(86, 86, 114)',
    },
    button: {
        default: 'rgb(86, 86, 114)',
        hover: 'rgb(223, 223, 225)',
        focus: 'rgb(228, 228, 228)',
        disabled: 'rgba(86, 86, 114, 0.3)',
    },
}, 'dark');

export const datatableCustomStyles = {
    pagination: {
        style: {
            color: 'rgb(86, 86, 114)',
        },
        pageButtonsStyle: {
            borderRadius: '4px',
            height: '32px',
            width: '32px',
            padding: '4px',
            margin: '0 4px',
            cursor: 'pointer',
            transition: 'background-color 0.2s',
            color: 'rgb(86, 86, 114)',
            fill: 'rgb(86, 86, 114)',
            backgroundColor: 'transparent',
            '&:disabled': {
                cursor: 'unset',
                color: 'rgba(86, 86, 114, 0.3)',
                fill: 'rgba(86, 86, 114, 0.3)',
            },
            '&:hover:not(:disabled)': {
                backgroundColor: 'rgba(86, 86, 114, 0.1)',
            },
            '&:focus': {
                outline: 'none',
                backgroundColor: 'rgba(86, 86, 114, 0.1)',
            },
        },
    },
};
